/* Silk Scarfs - comportements des sections d'accueil.
   Deux choses seulement :
   1. la poignee avant/arriere (ss-rv) ;
   2. le filtre par taille du folio (ss-fz).
   Le HTML porte la classe ss-hjs posee par chaque section AVANT ce fichier ; si le fichier ne
   charge pas, le onerror la retire et le CSS masque les commandes : tout reste lisible. */
(function () {
  'use strict';

  /* (04/10) chaque section d'accueil appelle ce fichier : une seule copie doit cabler la page */
  if (window.__ssHomeJs) return;
  window.__ssHomeJs = true;

  /* ---- Avant / arriere ------------------------------------------------ */
  function initReverse(root) {
    var inputs = root.querySelectorAll('[data-ss-rv]');
    for (var i = 0; i < inputs.length; i++) {
      (function (input) {
        var media = input.closest ? input.closest('.ss-rv__media') : null;
        if (!media || media.getAttribute('data-ss-on') === '1') return;
        media.setAttribute('data-ss-on', '1');

        function apply() {
          media.style.setProperty('--ss-pos', input.value + '%');
        }
        input.addEventListener('input', apply);
        input.addEventListener('change', apply);
        apply();
      })(inputs[i]);
    }
  }

  /* ---- Filtre par taille ---------------------------------------------- */
  function initSizeFilter(root) {
    var bars = root.querySelectorAll('.ss-fz');
    for (var i = 0; i < bars.length; i++) {
      (function (bar) {
        if (bar.getAttribute('data-ss-on') === '1') return;
        var wrap = bar.parentNode;
        if (!wrap) return;
        var grid = wrap.querySelector('[data-ss-fz-grid]');
        if (!grid) return;
        bar.setAttribute('data-ss-on', '1');

        var none = wrap.querySelector('[data-ss-fz-none]');
        var pills = [].slice.call(bar.querySelectorAll('[data-ss-fz]'));
        var cards = [].slice.call(grid.children);

        function select(value) {
          for (var p = 0; p < pills.length; p++) {
            var on = pills[p].getAttribute('data-ss-fz') === value;
            if (on) { pills[p].classList.add('is-on'); } else { pills[p].classList.remove('is-on'); }
            pills[p].setAttribute('aria-pressed', on ? 'true' : 'false');
          }
          var shown = 0;
          for (var c = 0; c < cards.length; c++) {
            var list = (cards[c].getAttribute('data-ss-sizes') || '').split(/\s+/);
            var ok = value === '' || list.indexOf(value) !== -1;
            cards[c].hidden = !ok;
            if (ok) shown++;
          }
          grid.hidden = shown === 0;
          if (none) none.hidden = shown !== 0;
          // le carrousel mobile repart au debut, sinon on reste sur une zone vide
          if (grid.scrollLeft) grid.scrollLeft = 0;
        }

        for (var k = 0; k < pills.length; k++) {
          (function (pill) {
            pill.addEventListener('click', function () {
              select(pill.getAttribute('data-ss-fz'));
            });
          })(pills[k]);
        }
      })(bars[i]);
    }
  }

  /* ---- Onglets d'etiquette des guides ---------------------------------- */
  function initGuides(root) {
    var bars = root.querySelectorAll('[data-ss-gd-tabs]');
    for (var i = 0; i < bars.length; i++) {
      (function (bar) {
        if (bar.getAttribute('data-ss-on') === '1') return;
        var wrap = bar.parentNode;
        if (!wrap) return;
        var grid = wrap.querySelector('[data-ss-gd-grid]');
        if (!grid) return;
        bar.setAttribute('data-ss-on', '1');

        var none = wrap.querySelector('[data-ss-gd-none]');
        var tabs = [].slice.call(bar.querySelectorAll('[data-ss-gd]'));
        var cards = [].slice.call(grid.children);

        function select(key) {
          for (var p = 0; p < tabs.length; p++) {
            var on = tabs[p].getAttribute('data-ss-gd') === key;
            if (on) { tabs[p].classList.add('is-on'); } else { tabs[p].classList.remove('is-on'); }
            tabs[p].setAttribute('aria-pressed', on ? 'true' : 'false');
          }
          var shown = 0;
          for (var c = 0; c < cards.length; c++) {
            var list = (cards[c].getAttribute('data-ss-gd-tags') || '').split(/\s+/);
            var ok = key === '' || list.indexOf(key) !== -1;
            cards[c].hidden = !ok;
            if (ok) shown++;
          }
          grid.hidden = shown === 0;
          if (none) none.hidden = shown !== 0;
          if (grid.scrollLeft) grid.scrollLeft = 0;
        }

        for (var k = 0; k < tabs.length; k++) {
          (function (tab) {
            tab.addEventListener('click', function () { select(tab.getAttribute('data-ss-gd')); });
          })(tabs[k]);
        }
        // l'onglet actif au chargement decide de ce qui est visible
        var on = bar.querySelector('.is-on');
        if (on) select(on.getAttribute('data-ss-gd'));
      })(bars[i]);
    }
  }

  /* ---- Fleches du rail (folio) ----------------------------------------
     Un clic fait defiler d'autant de cartes qu'il en tient entierement a l'ecran. Les fleches
     n'apparaissent que si la rangee deborde, s'effacent aux deux bouts, et se recalculent au
     defilement, au redimensionnement et quand le filtre par taille masque des cartes. */
  function initRailNav(root) {
    var navs = root.querySelectorAll('[data-ss-railnav]');
    for (var i = 0; i < navs.length; i++) {
      (function (nav) {
        if (nav.getAttribute('data-ss-on') === '1') return;
        var first = nav.querySelector('[aria-controls]');
        var track = first ? document.getElementById(first.getAttribute('aria-controls')) : null;
        if (!track) return;
        nav.setAttribute('data-ss-on', '1');
        var btns = [].slice.call(nav.querySelectorAll('[data-ss-rail-dir]'));
        var frame = 0;

        function stepWidth() {
          var cards = [].slice.call(track.children).filter(function (c) { return !c.hidden; });
          if (!cards.length) return track.clientWidth;
          var w = cards[0].getBoundingClientRect().width;
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          /* +1 : largeurs au sous-pixel pres, 4 cartes pleines donnaient 3,999 et un pas de 3 cartes */
          var per = Math.max(1, Math.floor((track.clientWidth + gap + 1) / (w + gap)));
          return per * (w + gap);
        }
        // les fleches sont posees sur les cotes du rail, a mi-hauteur de l'image des cartes
        function placeArrows() {
          var cards = [].slice.call(track.children).filter(function (c) { return !c.hidden; });
          if (!cards.length) return;
          var media = cards[0].querySelector('.ss-pc__media, .ss-card__media, img');
          if (!media) return;
          var r = media.getBoundingClientRect();
          var t = track.getBoundingClientRect();
          if (!r.height) return;
          nav.style.setProperty('--ss-rail-arrow-y', Math.round(r.top - t.top + r.height / 2) + 'px');
        }
        function update() {
          frame = 0;
          var over = !track.hidden && track.scrollWidth > track.clientWidth + 2;
          nav.hidden = !over;
          if (!over) return;
          placeArrows();
          var max = track.scrollWidth - track.clientWidth;
          btns.forEach(function (b) {
            var dir = parseInt(b.getAttribute('data-ss-rail-dir'), 10);
            b.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
          });
        }
        function schedule() { if (!frame) frame = window.requestAnimationFrame(update); }

        btns.forEach(function (b) {
          b.addEventListener('click', function () {
            var dir = parseInt(b.getAttribute('data-ss-rail-dir'), 10) || 1;
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollBy({ left: dir * stepWidth(), behavior: reduce ? 'auto' : 'smooth' });
          });
        });
        track.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        if (window.MutationObserver) {
          new MutationObserver(schedule).observe(track, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
        }
        update();
      })(navs[i]);
    }
  }

  /* ---- Glisser le rail a la souris --------------------------------------
     Sur ordinateur, on attrape le rail et on le fait defiler de gauche a droite. Le glisse ne
     demarre qu'au-dela de 6 px (un simple clic sur une taille, un coloris ou le bouton reste un
     clic), et le clic qui suit un glisse est avale pour ne pas ouvrir la fiche par erreur.
     Tactile et stylet gardent le defilement natif. */
  /* Rail a nombre entier de cartes : apres un glisse, on se cale sur le bord gauche de la carte la
     plus proche, pour qu'aucune carte ne reste coupee. */
  function settle(track) {
    var cards = [].slice.call(track.children).filter(function (c) { return !c.hidden; });
    if (!cards.length) return;
    var t = track.getBoundingClientRect();
    var max = track.scrollWidth - track.clientWidth;
    var here = track.scrollLeft, best = 0, dist = Infinity;
    cards.forEach(function (c) {
      var x = Math.min(max, Math.max(0, c.getBoundingClientRect().left - t.left - track.clientLeft + here));
      if (Math.abs(x - here) < dist) { dist = Math.abs(x - here); best = x; }
    });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (dist > 1) track.scrollTo({ left: best, behavior: reduce ? 'auto' : 'smooth' });
  }

  function initRailDrag(root) {
    var tracks = root.querySelectorAll('.ss-track--d-rail, .ss-track--m-carousel');
    for (var i = 0; i < tracks.length; i++) {
      (function (track) {
        if (track.getAttribute('data-ss-drag') === '1') return;
        track.setAttribute('data-ss-drag', '1');
        var down = false, moved = false, startX = 0, startLeft = 0, pid = null;

        function canScroll() { return track.scrollWidth > track.clientWidth + 2; }
        function swallow(e) { e.preventDefault(); e.stopPropagation(); }

        track.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          if (canScroll()) { track.classList.add('is-draggable'); } else { track.classList.remove('is-draggable'); }
        });
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || !canScroll()) return;
          if (e.target.closest && e.target.closest('input, select, textarea')) return;
          down = true; moved = false; pid = e.pointerId;
          startX = e.clientX; startLeft = track.scrollLeft;
        });
        track.addEventListener('pointermove', function (e) {
          if (!down || e.pointerId !== pid) return;
          var dx = e.clientX - startX;
          if (!moved) {
            if (Math.abs(dx) < 6) return;
            moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(pid); } catch (err) {}
          }
          track.scrollLeft = startLeft - dx;
          e.preventDefault();
        });
        function end(e) {
          if (!down || (e && e.pointerId !== pid)) return;
          down = false;
          if (!moved) return;
          track.classList.remove('is-dragging');
          if (track.classList.contains('ss-track--d-whole')) settle(track);
          track.addEventListener('click', swallow, true);
          window.setTimeout(function () { track.removeEventListener('click', swallow, true); }, 0);
        }
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        track.addEventListener('lostpointercapture', end);
        // pas de glisser-deposer natif des images et des liens pendant qu'on attrape le rail
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      })(tracks[i]);
    }
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initReverse(scope);
    initSizeFilter(scope);
    initGuides(scope);
    initRailNav(scope);
    initRailDrag(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // editeur de theme : une section rechargee doit se recabler
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
